import { render, staticRenderFns } from "./UpdateEmailWorkflowPage.vue?vue&type=template&id=5661d91b&scoped=true"
import script from "./UpdateEmailWorkflowPage.vue?vue&type=script&lang=js"
export * from "./UpdateEmailWorkflowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661d91b",
  null
  
)

export default component.exports